import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserSelectedPermissionList = () => {
  const [selectedPermissionListLoading, setSelectedPermissionListLoading] =
    useState(true);
  const [selectedPermissionList, setSelectedPermissionList] = useState([]);
  const [pageRef, setPageRef] = useState(null);
  useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const getSelectedPermissionList = ({ Guid, Page, Count, Term = '' }) => {
    setSelectedPermissionListLoading(true);

    axiosClient
      .get('SettingAccount/User/Permission/SelectedList', {
        params: { Guid, Page, Count, Term },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);
          setSelectedPermissionList(
            res.data.value.list.map(permission => ({
              id: permission.permissionGuid,
              display: permission.display,
              selected: permission.selected,
            })),
          );
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setSelectedPermissionListLoading(false));
  };

  return {
    getSelectedPermissionList,
    selectedPermissionListLoading,
    selectedPermissionList,
    pageRef,
  };
};

export default useUserSelectedPermissionList;
